import { formatDate } from '@angular/common';
import { Component, AfterViewInit, ViewChild, ChangeDetectorRef} from '@angular/core';
import {MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import { MatTableDataSource } from '@angular/material/table';
import { ComprobantesService } from 'src/app/services/comprobantes.service';
import {MatPaginator, MatPaginatorIntl} from '@angular/material/paginator';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';

export const DATE_FORMATS = {
  parse: {
      dateInput: 'DD/MM/YYYY',
  },
  display: {
      dateInput: 'DD/MM/YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-ord-pago',
  templateUrl: './ord-pago.component.html',
  styleUrls: ['./ord-pago.component.scss'],
  providers: [{ provide: DateAdapter, useClass:MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
  {provide: MAT_DATE_LOCALE, useValue: 'es-ES'},
  {provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS}]
})
export class OrdPagoComponent implements AfterViewInit{
  displayedColumns: string[] = ['descrip', 'num', 'fecha','total','descarga','cantidad_reten'];
  dataSource: any;
  fecha_desde_moment: moment.Moment | null = null;
  fecha_hasta_moment: moment.Moment | null = null;
  fecha_desde: any = null;
  fecha_hasta: any = null;
  value: any ='';
  estado: any='';
  estaVacio:boolean=true;
  data:any;
  contador: number = 0;
  mult: any;

  constructor(public compService:ComprobantesService,private paginator2: MatPaginatorIntl, private cdr: ChangeDetectorRef) {
    this.paginator2.itemsPerPageLabel = "Registros por página" }
    nro_cuenta: any = localStorage.getItem('cuenta');
    nro_cli: any = '';
    nro_prov: any = localStorage.getItem('nro_proveedor');
    isLoadingResults: Boolean = true;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  ngAfterViewInit() {
    this.consultar();
  }

  desc_comp(codigo:any,estado:any){
    this.compService.bajarComp(this.nro_cuenta,this.nro_cli,this.nro_prov,estado,codigo);
  }

  dateChanged($event:any){
    // fecha= new Date($event.target.value);
    if($event.target.value){
      this.value = new Date($event.target.value);
      this.fecha_desde = formatDate(this.value, 'yyyyMMdd', 'en-US'); 
      } else {
        this.fecha_desde = '';
      }
      this.consultar();
     }

    dateChanged2($event:any){
    if($event.target.value){
      this.value = new Date($event.target.value);
      this.fecha_hasta = formatDate(this.value, 'yyyyMMdd', 'en-US'); 
      } else {
      this.fecha_hasta = '';
      }
      this.consultar();
    }

    consultar(){
      this.isLoadingResults = true;
      this.compService.consulComp(
        this.nro_cuenta,
        this.nro_cli,
        this.nro_prov,
        this.fecha_desde,
        this.fecha_hasta,
        this.estado,
        'PRO'  
        )
      .then((data:any)=>{

        try {
          if(data){
            this.dataSource = new MatTableDataSource(data);
            this.dataSource.paginator = this.paginator;
            this.data = data;
            this.contador=0;
            for (let i = 0; i < data.length; i++) {
              this.mult = Number(data[i].total) * Number(data[i].mone_coti);
              this.contador = Number(this.contador) + Number(this.mult);
            }
            if(data[0] && data[0].fecha_desde_consulta && data[0].fecha_hasta_consulta){
              this.setFechasDesdeRespuesta(data[0].fecha_desde_consulta, data[0].fecha_hasta_consulta);
            }
            this.data.length==0?this.estaVacio=false:this.estaVacio=true;
          }  
        } catch (error) {}

        this.isLoadingResults = false;
 
    })
    }

      /**
   * Setea las fechas desde/hasta cuando vienen de la API.
   * Formato recomendado: YYYY-MM-DD (ej: "2024-11-02").
   * También acepta YYYYMMDD.
   */
  setFechasDesdeRespuesta(fecha_desde: string, fecha_hasta: string): void {
    if (fecha_desde) {
      const mDesde = moment(fecha_desde, ['YYYY-MM-DD', 'YYYYMMDD'], true);
      if (mDesde.isValid()) {
        this.fecha_desde_moment = mDesde;
        this.fecha_desde = this.fecha_desde_moment.format('YYYYMMDD');
      }
    }
    if (fecha_hasta) {
      const mHasta = moment(fecha_hasta, ['YYYY-MM-DD', 'YYYYMMDD'], true);
      if (mHasta.isValid()) {
        this.fecha_hasta_moment = mHasta;
        this.fecha_hasta = this.fecha_hasta_moment.format('YYYYMMDD');
      }
    }
    this.cdr.detectChanges();
  }

  
}
